import { render, staticRenderFns } from "./notificationList.vue?vue&type=template&id=79f43478&scoped=true&lang=html"
import script from "./notificationList.vue?vue&type=script&lang=js"
export * from "./notificationList.vue?vue&type=script&lang=js"
import style0 from "./notificationList.vue?vue&type=style&index=0&id=79f43478&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79f43478",
  null
  
)

export default component.exports